import { docsPageUrl } from "@/utils/docsSite";

// Ссылки на страницы справки из шаблонов — глобальный mixin (main.js: Vue.mixin), по образцу
// tableFooterMixin. Сайт справки — по стране филиала и языку интерфейса (FT-205, utils/docsSite).
export default {
  methods: {
    docsLink(path) {
      return docsPageUrl(this.$store?.getters?.getCompany?.company, this.$i18n?.locale, path);
    },
  },
};
